var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 29,
    viewBox: "0 0 14 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5306 9.7417C10.1946 9.7417 9.92188 10.0144 9.92188 10.3504C9.92188 10.6864 10.1946 10.9591 10.5306 10.9591C10.8666 10.9591 11.1393 10.6864 11.1393 10.3504C11.1393 10.0144 10.8666 9.7417 10.5306 9.7417Z",
    fill: "#52ACBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87826 0.00341797C3.19955 0.00341797 0 2.97732 0 6.69907V21.3078C0 25.0306 3.20077 28.0034 6.87826 28.0034C10.5504 28.0034 13.7565 25.0353 13.7565 21.3078V6.69907C13.7565 2.97623 10.5558 0.00341797 6.87826 0.00341797ZM12.5391 21.3078C12.5391 24.3905 9.84182 26.786 6.87826 26.786C3.80977 26.786 1.21739 24.2773 1.21739 21.3078V14.6121H12.5391V21.3078ZM12.5391 13.3947H1.21739V6.69907C1.21739 3.72955 3.80977 1.22081 6.87826 1.22081C9.94676 1.22081 12.5391 3.72955 12.5391 6.69907V13.3947Z",
    fill: "#12428A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29852 2.68303C7.98157 2.57085 7.63376 2.7366 7.52146 3.05342C7.40915 3.37031 7.57502 3.71824 7.89191 3.83055C9.10577 4.26071 9.9213 5.41395 9.9213 6.70018V7.91757C9.9213 8.25375 10.1938 8.52627 10.53 8.52627C10.8662 8.52627 11.1387 8.25375 11.1387 7.91757V6.70018C11.1387 4.89948 9.99733 3.28509 8.29852 2.68303Z",
    fill: "#12428A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/medicine.938fa644.svg";
export { ForwardRef as ReactComponent };